import React from 'react';
import type { ButtonProps } from '../../../button';
import Button from '../../../button';
import { ModalActionsSC } from './modal-actions.styled';

type TActionProps = Omit<
  ButtonProps,
  'size' | 'block' | 'children' | 'leftArrow' | 'rightArrow' | 'ref'
> & {
  key: string;
  label: React.ReactNode;
};

interface ModalActionsProps
  extends Omit<
    React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement>,
    'ref' | 'children'
  > {
  actions?: TActionProps[];
}

const ModalActions: React.FunctionComponent<ModalActionsProps> = ({ actions, ...rest }) => {
  return (
    <ModalActionsSC {...rest}>
      {actions?.map(({ key, label, ...bp }) => (
        <Button {...bp} key={key} block={false} size="medium">
          {label}
        </Button>
      ))}
    </ModalActionsSC>
  );
};

export default ModalActions;
